import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["searchInput", "clearButton", "sortLabel", "sortWrapper"];

  connect() {
    this.currentSort = localStorage.getItem("boarding-calendar-sort") || "time";

    if (this.hasSortLabelTarget) {
      var labels = { time: "Time", pet_name: "Pet Name", service_name: "Service Name", client_last_name: "Client Last Name" };
      this.sortLabelTarget.textContent = labels[this.currentSort] || "Time";
    }

    // Show sort only on In Facility tab
    var controller = this;
    var activeTabHref = localStorage.getItem("activeTab");
    var $activeTab = $(this.element).find('.js-boarding-tab.active');
    var isInFacility = (activeTabHref === '#in-facility') || ($activeTab.length && $activeTab.attr('href') === '#in-facility');
    if (isInFacility && this.hasSortWrapperTarget) {
      $(this.sortWrapperTarget).show();
    }

    $(document).on('click.boardingSearchFilter', '.js-boarding-tab', function () {
      var href = $(this).attr('href');
      if (!controller.hasSortWrapperTarget) return;
      if (href === '#in-facility') {
        $(controller.sortWrapperTarget).show();
      } else {
        $(controller.sortWrapperTarget).hide();
      }
    });
  }

  disconnect() {
    $(document).off('click.boardingSearchFilter');
  }

  sort(event) {
    event.preventDefault();
    var sortValue = event.currentTarget.dataset.sortValue;
    var sortLabel = event.currentTarget.dataset.sortLabel;

    this.currentSort = sortValue;
    localStorage.setItem("boarding-calendar-sort", sortValue);

    if (this.hasSortLabelTarget) {
      this.sortLabelTarget.textContent = sortLabel;
    }

    this.sortRows();
  }

  sortRows() {
    var sortValue = this.currentSort;

    var comparator = function (a, b) {
      var aVal, bVal;
      if (sortValue === "pet_name") {
        aVal = (a.dataset.petName || "").toLowerCase();
        bVal = (b.dataset.petName || "").toLowerCase();
      } else if (sortValue === "service_name") {
        aVal = (a.dataset.serviceName || "").toLowerCase();
        bVal = (b.dataset.serviceName || "").toLowerCase();
      } else if (sortValue === "client_last_name") {
        aVal = (a.dataset.clientName || "").toLowerCase();
        bVal = (b.dataset.clientName || "").toLowerCase();
      } else {
        aVal = parseInt(a.dataset.startAt || "0", 10);
        bVal = parseInt(b.dataset.startAt || "0", 10);
        return aVal - bVal;
      }
      return aVal.localeCompare(bVal);
    };

    // Sort In Facility checkin rows
    $(this.element).find("table tbody").each(function () {
      var $tbody = $(this);
      var rows = $tbody.find(".js-checkin-checkout-row").get();
      if (rows.length === 0) return;

      rows.sort(comparator);

      $.each(rows, function (_, row) {
        $tbody.append(row);
      });
    });

  }

  search() {
    var query = this.searchInputTarget.value.toLowerCase();

    // Filter In Facility checkin rows
    var rows = $(this.element).find(".js-checkin-checkout-row");
    rows.each(function () {
      var text = $(this).text().toLowerCase();
      $(this).toggleClass("d-none", query !== "" && text.indexOf(query) === -1);
    });

    // Filter Feed & Care cards
    var feedCareCards = $(this.element).find(".js-feed-care-card");
    feedCareCards.each(function () {
      var text = $(this).text().toLowerCase() + " " + (this.dataset.serviceName || "").toLowerCase();
      $(this).toggleClass("d-none", query !== "" && text.indexOf(query) === -1);
    });

    // Filter Calendar bookings (must remove d-flex AND add d-none to fully hide)
    var calendarEl = document.getElementById('js-boarding-calendar');
    if (calendarEl) {
      calendarEl.querySelectorAll('a.js-calendar-booking, a.js-calendar-booking-hidden').forEach(function (link) {
        var text = link.textContent.toLowerCase();
        if (query !== "" && text.indexOf(query) === -1) {
          link.classList.remove('d-flex', 'js-calendar-booking');
          link.classList.add('d-none', 'js-calendar-booking-hidden');
        } else {
          link.classList.remove('d-none', 'js-calendar-booking-hidden');
          link.classList.add('d-flex', 'js-calendar-booking');
        }
      });
    }

    if (query !== "") {
      $(this.clearButtonTarget).removeClass("d-none");
    } else {
      $(this.clearButtonTarget).addClass("d-none");
    }

    // Handle no-results per container that has checkin rows
    // For card-bodies with #in-facility-list, target that div specifically
    $(this.element).find(".card-body").each(function () {
      var $cardBody = $(this);
      var $facilityList = $cardBody.find("#in-facility-list");
      var $container = $facilityList.length > 0 ? $facilityList : $cardBody;
      var cardRows = $container.find(".js-checkin-checkout-row");
      if (cardRows.length === 0) return;

      var $noResults = $container.find(".js-search-no-results");
      var visibleRows = cardRows.filter(":not(.d-none)").length;

      if (query !== "" && visibleRows === 0) {
        if ($noResults.length === 0) {
          $container.append("<div class='text-center py-4 js-search-no-results'>No search results for '" + query + "'</div>");
        } else {
          $noResults.html("No search results for '" + query + "'").removeClass("d-none");
        }
      } else {
        $noResults.remove();
      }
    });
  }

  clearSearch(event) {
    event.preventDefault();
    this.searchInputTarget.value = "";
    $(this.clearButtonTarget).addClass("d-none");
    $(this.element).find(".js-checkin-checkout-row").removeClass("d-none");
    $(this.element).find(".js-feed-care-card").removeClass("d-none");
    var calendarEl = document.getElementById('js-boarding-calendar');
    if (calendarEl) {
      calendarEl.querySelectorAll('a.js-calendar-booking-hidden').forEach(function (link) {
        link.classList.remove('d-none', 'js-calendar-booking-hidden');
        link.classList.add('d-flex', 'js-calendar-booking');
      });
    }
    $(this.element).find(".js-search-no-results").remove();
  }
}
